import type { DirectoryLocation } from "@/types/directory";

interface TalukListProps {
  districtName: string;
  taluks: DirectoryLocation[];
  selected: string;
  onSelect: (slug: string) => void;
}

export default function TalukList({
  districtName,
  taluks,
  selected,
  onSelect,
}: TalukListProps) {
  const itemClass = (isActive: boolean) =>
    `flex w-full cursor-pointer items-center justify-between gap-3 rounded-md px-3 py-2.5 text-left text-sm font-medium transition-colors duration-200 ${
      isActive
        ? "bg-primary-500 text-background-50"
        : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
    }`;

  const countClass = (isActive: boolean) =>
    `shrink-0 rounded-full px-2 py-0.5 text-[11px] font-bold ${
      isActive ? "bg-background-50/25 text-background-50" : "bg-background-200 text-foreground-600"
    }`;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h3 className="flex items-center gap-2 font-heading text-xs font-bold uppercase tracking-wider text-foreground-900">
        <span className="flex h-4 w-4 items-center justify-center text-primary-600">
          <i className="ri-community-line text-base" />
        </span>
        Taluks in {districtName}
      </h3>

      <ul className="mt-4 space-y-1">
        <li>
          <button
            type="button"
            onClick={() => onSelect("")}
            aria-pressed={selected === ""}
            className={itemClass(selected === "")}
          >
            <span className="flex items-center gap-2">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-map-pin-2-line text-base" />
              </span>
              All {districtName}
            </span>
          </button>
        </li>

        {taluks.map((taluk) => {
          const isActive = selected === taluk.slug;
          return (
            <li key={taluk.id}>
              <button
                type="button"
                onClick={() => onSelect(taluk.slug)}
                aria-pressed={isActive}
                className={itemClass(isActive)}
              >
                <span className="flex min-w-0 items-center gap-2">
                  <span className="flex h-4 w-4 shrink-0 items-center justify-center">
                    <i className="ri-road-map-line text-base" />
                  </span>
                  <span className="truncate">{taluk.name}</span>
                </span>
                <span className={countClass(isActive)}>
                  {taluk.businessCount.toLocaleString("en-IN")}
                </span>
              </button>
            </li>
          );
        })}
      </ul>

      {taluks.length === 0 ? (
        <p className="mt-3 text-xs text-foreground-500">
          Taluk data for this district is being updated.
        </p>
      ) : null}
    </div>
  );
}